import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const LunchList = React.lazy(() => import("@/pages/lunch/LunchList"));
const LunchReport = React.lazy(() => import("@/pages/lunch/LunchReport"));

const AdminLunch = [
  {
    path: "lunch",
    element: (
      <SuspenseWrapper>
        <LunchList />
      </SuspenseWrapper>
    ),
  },
  {
    path: "lunchReport",
    element: (
      <SuspenseWrapper>
        <LunchReport />
      </SuspenseWrapper>
    ),
  },
];

export default AdminLunch;
